// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";

// import en from "./locales/en/translation.json";
// import te from "./locales/te/translation.json";
// import hi from "./locales/hi/translation.json";

// i18n.use(initReactI18next).init({
//   resources: {
//     en: { translation: en },
//     te: { translation: te },
//     hi: { translation: hi }
//   },
//   lng: localStorage.getItem("lang") || "en",
//   fallbackLng: "en",
//   interpolation: {
//     escapeValue: false
//   }
// });

// export default i18n;

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translateText } from "./services/translateService";

import en from "./locales/en/translation.json";
import te from "./locales/te/translation.json";
import hi from "./locales/hi/translation.json";
import ta from "./locales/ta/translation.json";
import kn from "./locales/kn/translation.json";
import bn from "./locales/bn/translation.json";
import mr from "./locales/mr/translation.json";
import gu from "./locales/gu/translation.json";
import ur from "./locales/ur/translation.json";
import ml from "./locales/ml/translation.json";
import or from "./locales/or/translation.json";
const SUPPORTED_LANGS = ["en", "te", "hi", "ta", "kn", "ml", "bn", "mr", "gu", "ur", "or"];

const normalizeLanguage = (language) => {
  const normalized = (language || "en").toString().trim().toLowerCase();
  const base = normalized.split("-")[0];
  return SUPPORTED_LANGS.includes(base) ? base : "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    te: { translation: te },
    hi: { translation: hi },
    ta: { translation: ta },
    kn: { translation: kn },
    ml: { translation: ml },
    bn: { translation: bn },
    mr: { translation: mr },
    gu: { translation: gu },
    ur: { translation: ur },
    or: { translation: or }
  },
  lng: normalizeLanguage(localStorage.getItem("lang")),
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGS,
  interpolation: {
    escapeValue: false
  }
});

const AUTO_TRANSLATE_LANGS = new Set(["te", "hi", "kn", "ml", "bn", "mr", "gu", "ur", "or"]);
const IN_FLIGHT_BY_LANGUAGE = new Set();
const TRANSLATION_CONCURRENCY = 4;

const getCacheKey = (language, key) => `i18n-auto-${language}-${key}`;

const isCorruptedTranslation = (value) => {
  if (typeof value !== "string") return false;
  if (/[ÃÂâà�]/.test(value) || value.includes("\uFFFD")) return true;
  const questionCount = (value.match(/\?/g) || []).length;
  return questionCount >= 3;
};

const hasNativeScript = (language, value) => {
  if (typeof value !== "string") return false;
  if (language === "hi") return /[\u0900-\u097F]/.test(value);
  if (language === "te") return /[\u0C00-\u0C7F]/.test(value);
  if (language === "kn") return /[\u0C80-\u0CFF]/.test(value);
  if (language === "bn") return /[\u0980-\u09FF]/.test(value);
  if (language === "mr") return /[\u0900-\u097F]/.test(value);
  if (language === "gu") return /[\u0A80-\u0AFF]/.test(value);
  if (language === "ur") return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(value);
  if (language === "ml") return /[\u0D00-\u0D7F]/.test(value);
  if (language === "or") return /[\u0B00-\u0B7F]/.test(value);
  return true;
};

const isMostlyEnglish = (value) => {
  if (typeof value !== "string" || !value.trim()) return false;
  const hasLatin = /[A-Za-z]/.test(value);
  const hasNative =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u0900-\u097F\u0980-\u09FF\u0A80-\u0AFF\u0B00-\u0B7F\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F]/.test(
      value
    );
  return hasLatin && !hasNative;
};

const isUsableLocalizedValue = (language, value, baseValue = "") => {
  if (typeof value !== "string" || !value.trim()) return false;
  if (isCorruptedTranslation(value)) return false;
  if (value === baseValue) return false;
  if (isMostlyEnglish(value)) return false;
  return hasNativeScript(language, value);
};

const cleanTranslatedText = (value) => {
  if (typeof value !== "string") return "";

  return value
    .replace(/^\s*(hindi|telugu|kannada|bengali|marathi|gujarati|urdu|translation)\s*[:-]\s*/i, "")
    .replace(
      /^\s*(\u0939\u093f\u0902\u0926\u0940 \u0905\u0928\u0941\u0935\u093e\u0926|\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41 \u0c05\u0c28\u0c41\u0c35\u0c3e\u0c26\u0c02|\u0c95\u0ca8\u0ccd\u0ca8\u0ca1 \u0c85\u0ca8\u0cc1\u0cb5\u0cbe\u0ca6|\u09ac\u09be\u0982\u09b2\u09be \u0985\u09a8\u09c1\u09ac\u09be\u09a6|\u092e\u0930\u093e\u0920\u0940 \u0905\u0928\u0941\u0935\u093e\u0926|\u0a97\u0ac1\u0a9c\u0ab0\u0abe\u0aa4\u0ac0 \u0a85\u0aa8\u0ac1\u0ab5\u0abe\u0aa6|\u0627\u0631\u062f\u0648 \u062a\u0631\u062c\u0645\u06c1)\s*[:-]\s*/i,
      ""
    )
    .trim();
};

const isAcceptableAutoTranslation = (language, translatedText, sourceText) => {
  const cleaned = cleanTranslatedText(translatedText);
  if (!cleaned) return false;
  if (cleaned === sourceText) return false;
  if (isCorruptedTranslation(cleaned)) return false;
  if (isMostlyEnglish(cleaned)) return false;

  const hasLetters = /[A-Za-z]/.test(sourceText || "");
  if (!hasLetters) return true;

  return hasNativeScript(language, cleaned);
};

const shouldAutoTranslate = (baseValue, targetValue) => {
  if (typeof baseValue !== "string" || !baseValue.trim()) return false;
  if (typeof targetValue !== "string" || !targetValue.trim()) return true;
  if (isCorruptedTranslation(targetValue)) return true;
  if (isMostlyEnglish(targetValue)) return true;
  return targetValue === baseValue;
};

const normalizeLanguageBundles = () => {
  const base = i18n.getResourceBundle("en", "translation");
  const hiBundle = { ...(i18n.getResourceBundle("hi", "translation") || {}) };
  const teBundle = { ...(i18n.getResourceBundle("te", "translation") || {}) };
  const knBundle = { ...(i18n.getResourceBundle("kn", "translation") || {}) };
  const mlBundle = { ...(i18n.getResourceBundle("ml", "translation") || {}) };
  const bnBundle = { ...(i18n.getResourceBundle("bn", "translation") || {}) };
  const mrBundle = { ...(i18n.getResourceBundle("mr", "translation") || {}) };
  const guBundle = { ...(i18n.getResourceBundle("gu", "translation") || {}) };
  const urBundle = { ...(i18n.getResourceBundle("ur", "translation") || {}) };
  const orBundle = { ...(i18n.getResourceBundle("or", "translation") || {}) };

  if (!base) return;

  let hiChanged = false;
  let teChanged = false;
  let knChanged = false;
  let mlChanged = false;
  let bnChanged = false;
  let mrChanged = false;
  let guChanged = false;
  let urChanged = false;
  let orChanged = false;

  Object.keys(base).forEach((key) => {
    const enValue = base[key];
    const hiValue = hiBundle[key];
    const teValue = teBundle[key];
    const knValue = knBundle[key];
    const mlValue = mlBundle[key];
    const bnValue = bnBundle[key];
    const mrValue = mrBundle[key];
    const guValue = guBundle[key];
    const urValue = urBundle[key];
    const orValue = orBundle[key];

    const hiValid = isUsableLocalizedValue("hi", hiValue, enValue);
    const teValid = isUsableLocalizedValue("te", teValue, enValue);
    const knValid = isUsableLocalizedValue("kn", knValue, enValue);
    const mlValid = isUsableLocalizedValue("ml", mlValue, enValue);
    const bnValid = isUsableLocalizedValue("bn", bnValue, enValue);
    const mrValid = isUsableLocalizedValue("mr", mrValue, enValue);
    const guValid = isUsableLocalizedValue("gu", guValue, enValue);
    const urValid = isUsableLocalizedValue("ur", urValue, enValue);
    const orValid = isUsableLocalizedValue("or", orValue, enValue);

    if (!hiValid && hiValue !== undefined) {
      delete hiBundle[key];
      hiChanged = true;
    }

    if (!teValid && teValue !== undefined) {
      delete teBundle[key];
      teChanged = true;
    }

    if (!knValid && knValue !== undefined) {
      delete knBundle[key];
      knChanged = true;
    }

    if (!mlValid && mlValue !== undefined) {
      delete mlBundle[key];
      mlChanged = true;
    }

    if (!bnValid && bnValue !== undefined) {
      delete bnBundle[key];
      bnChanged = true;
    }

    if (!mrValid && mrValue !== undefined) {
      delete mrBundle[key];
      mrChanged = true;
    }

    if (!guValid && guValue !== undefined) {
      delete guBundle[key];
      guChanged = true;
    }

    if (!urValid && urValue !== undefined) {
      delete urBundle[key];
      urChanged = true;
    }

    if (!orValid && orValue !== undefined) {
      delete orBundle[key];
      orChanged = true;
    }
  });

  if (hiChanged) {
    i18n.addResourceBundle("hi", "translation", hiBundle, false, true);
  }

  if (teChanged) {
    i18n.addResourceBundle("te", "translation", teBundle, false, true);
  }

  if (knChanged) {
    i18n.addResourceBundle("kn", "translation", knBundle, false, true);
  }

  if (mlChanged) {
    i18n.addResourceBundle("ml", "translation", mlBundle, false, true);
  }

  if (bnChanged) {
    i18n.addResourceBundle("bn", "translation", bnBundle, false, true);
  }

  if (mrChanged) {
    i18n.addResourceBundle("mr", "translation", mrBundle, false, true);
  }

  if (guChanged) {
    i18n.addResourceBundle("gu", "translation", guBundle, false, true);
  }

  if (urChanged) {
    i18n.addResourceBundle("ur", "translation", urBundle, false, true);
  }

  if (orChanged) {
    i18n.addResourceBundle("or", "translation", orBundle, false, true);
  }
};

const autoTranslateMissingKeys = async (language) => {
  if (!AUTO_TRANSLATE_LANGS.has(language)) return;
  if (IN_FLIGHT_BY_LANGUAGE.has(language)) return;

  const base = i18n.getResourceBundle("en", "translation");
  const target = i18n.getResourceBundle(language, "translation");

  if (!base || !target) return;

  IN_FLIGHT_BY_LANGUAGE.add(language);

  try {
    const merged = { ...target };
    const pendingKeys = [];

    Object.keys(base).forEach((key) => {
      if (!shouldAutoTranslate(base[key], merged[key])) return;

      const cached = localStorage.getItem(getCacheKey(language, key));
      if (cached && isAcceptableAutoTranslation(language, cached, base[key])) {
        merged[key] = cached;
        return;
      }

      if (cached) {
        localStorage.removeItem(getCacheKey(language, key));
      }

      pendingKeys.push(key);
    });

    i18n.addResourceBundle(language, "translation", merged, true, true);

    if (!pendingKeys.length) return;

    let cursor = 0;
    let changed = false;

    const worker = async () => {
      while (cursor < pendingKeys.length) {
        const key = pendingKeys[cursor];
        cursor += 1;

        const sourceText = base[key];
        const result = await translateText(sourceText, language);
        const translatedText = cleanTranslatedText(result?.translatedText || "");

        if (!isAcceptableAutoTranslation(language, translatedText, sourceText)) {
          continue;
        }

        merged[key] = translatedText;
        localStorage.setItem(getCacheKey(language, key), translatedText);
        changed = true;
      }
    };

    await Promise.all(
      Array.from(
        { length: Math.min(TRANSLATION_CONCURRENCY, pendingKeys.length) },
        () => worker()
      )
    );

    if (changed) {
      i18n.addResourceBundle(language, "translation", merged, true, true);
    }
  } finally {
    IN_FLIGHT_BY_LANGUAGE.delete(language);
  }
};

normalizeLanguageBundles();

const currentLanguage = normalizeLanguage(i18n.language || "en");
document.documentElement.lang = currentLanguage;
document.documentElement.dir = "ltr";

i18n.on("languageChanged", (language) => {
  const normalizedLanguage = normalizeLanguage(language);
  normalizeLanguageBundles();
  localStorage.setItem("lang", normalizedLanguage);
  document.documentElement.lang = normalizedLanguage;
  document.documentElement.dir = "ltr";
  autoTranslateMissingKeys(normalizedLanguage);
});

autoTranslateMissingKeys(currentLanguage);

export default i18n;
